// Direktiva na renderovanie KURZOVEJ PONUKY (prva uroven)
directives.popularSportsbookDirective.sportsBookPopular = {
    compile: function(data) {
        const template = `
            ${data.map(sport => `
                <details id="LC${sport.LeagueCupID}" class="SB-root SB-popular" sport-id="${sport.SportID}" region-id="${sport.RegionID}">
                    <summary class="sport" onclick="home.popularLeaguesModule.popularLeagueEvents(${sport.SportID}, ${sport.RegionID}, ${sport.LeagueCupID}); return false;">
                        <span class="ui-icon-sports sport-${sport.SportID} sport-icon-${sport.SportID} sport-color-${sport.SportID} region-${sport.RegionID}"></span>
                        <span class="flat-sport-name" style="display: none;">${sport.SportName}</span>
                        <span class="league-popular-wrapper">
                            <span class="flat-league sport-border-color-${sport.SportID}">
                                <span class="size22 flag_${sport.countryID ? sport.countryID : 'none'}"></span>
                                ${sport.RegionName} - ${sport.LeagueCupName}
                            </span>
                            <span class="sport-background-colored sport-bgColor-${sport.SportID}"></span>
                        </span>
                    </summary>
                </details>
            `).join("")}
        `;
        return template;
    },
    // Funkcia na renderovanie kurzovej ponuky popularnych lig
    render: function(placeholderId, data) {
        document.getElementById(placeholderId).innerHTML = this.compile(data);    
    }
};
